import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services';
import { WebappService } from './webapp.service';

@Component({
  selector: 'app-webapp',
  templateUrl: './webapp.component.html',
  styleUrls: ['./webapp.component.scss'],
})
export class WebappComponent implements OnInit {
  parametriUrl: any;
  loadingVisible = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private webAppService: WebappService,
    private authService: AuthService
  ) {
    this.parametriUrl = this.activatedRoute.snapshot.params;
    sessionStorage.setItem('data', JSON.stringify(this.parametriUrl));
    this.loadingVisible = true;
  }

  ngOnInit(): void {
    this.podaciFirma();
  }

  podaciFirma() {
    let podaci = {
      idfirma: +this.parametriUrl.idfirma,
      idkorisnik: +this.parametriUrl.idkorisnik,
      access_token: this.parametriUrl.token,
      imeModula: this.parametriUrl.modul,
    };
    
    this.webAppService.firmaInfo(podaci).subscribe((res) => {
      if (res.success == true) {
        sessionStorage.setItem('imeModula', 'proizvodnja');
        localStorage.setItem("iduser", res.data[0]["login"]);
        localStorage.setItem("user", res.data[0]["name"]);
        localStorage.setItem("idsecuser", res.data[0]["idsec_users"]);
        localStorage.setItem("token", this.parametriUrl.token);
        localStorage.setItem("firma", res.data[0]["fi_id"])
        sessionStorage.setItem("token", this.parametriUrl.token);
        this.authService.pravaKorisnika({ idkorisnik: res.data[0]['idsec_users'] }).subscribe((res) => {
          console.log("idkorisnik", res.data[0]['idsec_users']);
          if (res.success === true) {
            console.log(res)
            sessionStorage.setItem('pravakorisnika', JSON.stringify(res.data));
            
            //this.authService.logIn(l, p);
            this.authService.loggedIn = true;
            this.authService.imaToken();
          } else {
            sessionStorage.clear();
            localStorage.clear();
          }
        });
      } else {
        this.router.navigate(['/login-form']);
        sessionStorage.removeItem('data');
      }
    });
  }
}
